import type { FC } from 'react';

import { Form } from '../../Form.tsx';
import type { GenericFormProps } from '../../GenericFormProps.ts';
import { About } from './About.tsx';
import { schemaWithDescriptionRefinement } from './schema.ts';

export const AboutForm: FC<GenericFormProps<typeof About, typeof schemaWithDescriptionRefinement>> = ({
  onSubmit,
  buttonSlot,
  defaultValues,
}) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={defaultValues}
    formContentElement={About}
    schema={schemaWithDescriptionRefinement}
    onSubmit={onSubmit}
  />
);
